import services from 'api/services';
import { logError } from 'util/errors';

import {
  LOAD_CMS_CONTESTS_REQUEST,
  LOAD_CMS_CONTESTS_SUCCESS,
  LOAD_CMS_CONTESTS_FAILURE,
  CREATE_CMS_CONTEST_REQUEST,
  CREATE_CMS_CONTEST_SUCCESS,
  CREATE_CMS_CONTEST_FAILURE,
  DELETE_CMS_CONTEST_REQUEST,
  DELETE_CMS_CONTEST_SUCCESS,
  DELETE_CMS_CONTEST_FAILURE,
  RESET_UPDATED_IDS,
} from './constants';

const { ChallengeService } = services;

export const getContests = (id) => async (dispatch) => {
  try {
    dispatch({ type: LOAD_CMS_CONTESTS_REQUEST });
    const response = await ChallengeService.getContestsForCMS(id);
    dispatch({ type: LOAD_CMS_CONTESTS_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: LOAD_CMS_CONTESTS_FAILURE, error: ex.message });
  }
};

export const createContest = (id) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_CMS_CONTEST_REQUEST });
    const response = await ChallengeService.createContest(id);
    dispatch({ type: CREATE_CMS_CONTEST_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: CREATE_CMS_CONTEST_FAILURE, error: ex.message });
  }
};

export const deleteContest = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_CMS_CONTEST_REQUEST });
    const response = await ChallengeService.deleteContest(id);
    dispatch({ type: DELETE_CMS_CONTEST_SUCCESS, data: response });
  } catch (ex) {
    logError(ex);
    dispatch({ type: DELETE_CMS_CONTEST_FAILURE, error: ex.message });
  }
};

export const resetUpdatedIds = () => async (dispatch) => {
  dispatch({ type: RESET_UPDATED_IDS });
};
